<template>
  <div>
    <!-- Filters -->
    <b-card>
      <filters
        :customFiltersShow="true"
        :originImprovementFilterShow="true"
        :locationFilterShow="true"
        :dateRangeFilterShow="true"
        :resetDateButtonShow="true"
        :locationDefaultValue="true"
        :supervisorFilterShow="true"
        :origin="'improvement'"
        supervisorFilterPlaceholder="creator_filter"
        @changeFilter="updateFilter"
      />
    </b-card>

    <!-- Statistic Cards -->
    <b-row>
      <b-col sm="4">
        <statistic-card-vertical-total
          :statistic="statisticCardsData.total === undefined ? '-' : statisticCardsData.total"
          :isButton="true"
          :isSelected="activeState === 'total'"
          @filter="filterByState('total')"
        >
        </statistic-card-vertical-total>
      </b-col>

      <b-col sm="4">
        <statistic-card-vertical-completed
          :statistic="statisticCardsData.completed === undefined ? '-' : statisticCardsData.completed"
          :isButton="true"
          :isSelected="activeState === 'completed'"
          @filter="filterByState('completed')"
          >
        </statistic-card-vertical-completed>
      </b-col>

      <b-col sm="4">
        <statistic-card-vertical-pending
          :statistic="statisticCardsData.pending === undefined ? '-' : statisticCardsData.pending"
          :isButton="true"
          :isSelected="activeState === 'pending'"
          @filter="filterByState('pending')"
        >
        </statistic-card-vertical-pending>
      </b-col>

      <!-- <b-col sm="3">
        <statistic-card-vertical-overdue
          :statistic="statisticCardsData.overdue === undefined ? '-' : statisticCardsData.overdue"
          :isButton="true"
          :isSelected="activeState === 'overdue'"
          @filter="filterByState('overdue')"
        >
        </statistic-card-vertical-overdue>
      </b-col> -->
 
    </b-row>

    <!-- Improvement List -->
    <b-card class="pb-0 mb-1">
      <b-row class="pl-1">

        <!-- Search -->
        <b-col md="3">
          <b-form-group>
            <b-form-input
              v-model="searchQuery"
              type="search"
              class="d-inline-block"
              :placeholder="$t('message.search')"
              @input="searchTask"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Table -->
      <b-col cols="12">
        <b-table
          ref="refImprovementListTable"
          :empty-text="isLoading ? $t('message.loading') : $t('message.no_records')"
          show-empty=""
          :items="paginatedTaks"
          hover
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          :sort-desc.sync="isSortDirDesc"
          @row-clicked="handleTaskClick"
        >
          <!-- Tags -->
          <template #cell(tags)="data">
            <div class="m-0">
              <b-badge
                v-for="tag in data.item.tags"
                :key="tag"
                pill
                :variant="`light-${resolveTagVariant(tag)}`"
                class="text-capitalize mr-1"
              >{{ $t(`domain.${tag}`) }}
              </b-badge>
            </div>
          </template>

          <!-- Note -->
          <template #cell(formatNote)="data">
            <span v-b-tooltip.hover.v-primary.top="data.item.note">
              {{ data.item.formatNote }}
            </span>
          </template>

          <!-- Satate -->
          <template #cell(state)="data">
            <h6 :class="`text-nowrap mr-1 ${data.item.completed? 'text-success' : 'text-warning'}`">{{ $t(`${data.item.state}`)  }}</h6>
          </template>

          <!-- Action buttons -->
          <template #cell(actions)="data">
            <div class="d-flex align-items-center justify-content-start">
              <b-form-checkbox
                :checked="data.item.completed"
                @click.native.stop
                v-b-tooltip.hover.v-primary="!data.item.completed ? $t('mark_complete') : null"
                @change="updateTaskIsCompleted(data.item)"
                style="transform: scale(0.9); "
              />
              <ViewButton @clicked="handleTaskClick(data.item)"/>
              <DeleteButton @clicked="taskToDelete = data.item" v-b-modal="modalIdToDeletd"/>
            </div>
          </template>
        </b-table>
      </b-col>

      <!-- Modal to confirm delete action -->
      <b-modal
        :id="modalIdToDeletd"
        centered
        no-close-on-backdrop
        modal-class="modal-danger"
        ok-variant="danger"
        cancel-variant="outline-secondary"
        :title="$t('message.confirm_action')"
        :ok-title="$t('message.delete')"
        :cancel-title="$t('message.cancel')"
        @ok="removeTask(taskToDelete)"
      > {{ $t('message.confirm_delete_improvement') }}
      </b-modal>

      <!-- Task Handler -->
      <todo-task-handler-sidebar
        v-model="isTaskHandlerSidebarActive"
        :task="task"
        :clear-task-data="clearTaskData"
        :domains="domains"
        :optionsMetadata="optionsMetadata"
        :isImprovement="true"
        handlerId="tab"
        @remove-task="removeTask"
        @update-task="updateTask"
      />

      <!-- Pagination -->
      <b-col
        cols="12"
        class="d-flex justify-content-between flex-wrap"
      >
        <div class="mb-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{ $t('message.per_page') }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="[5,10,15,20,25,30,40,50,100]"
              class="w-50"
            />
          </b-form-group>
        </div>
        <div class="mb-1">
          <span class="text-muted">{{ $tc('message.paginationText', 0, { from: `${((currentPage * perPage) - perPage) + (tasks.length ? 1 : 0)}`, to: `${tasks.length + ((currentPage * perPage) - perPage)}`, total: `${totalTasks}` }) }}</span>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalTasks"
          :per-page="perPage"
          first-number=""
          last-number=""
          prev-class="prev-item"
          next-class="next-item"
        />
      </b-col>
    </b-card>

    <!-- Excel -->
    <b-col md="2" class="pb-1 pl-0">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="secondary"
        block    
      >
        <json-excel :data="dataExcel" :fields="excelFields">
          {{ $t('download_xlsx') }}
        </json-excel>
      </b-button>
    </b-col>
  </div>
</template>

<script>
import store from '@/store'
import { ref, watch, computed, onMounted } from '@vue/composition-api'
import { BFormInput, BBadge, BTable, BPagination, VBModal, BFormCheckbox, VBTooltip } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { useRouter } from '@core/utils/utils'
import todoStoreModule from './todoStoreModule'
import TodoTaskHandlerSidebar from './TodoTaskHandlerSidebar.vue'
import useCommonTodo from './useCommonTodo'
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'
import useCommonDashboards from '@/views/habit/useCommonDashboards'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import useCommon from "@/views/organization/useCommon"
import realmConnection from '@/views/habit/realm'
import Filters from "@/views/organization/Filters.vue"
import StatisticCardVerticalTotal from '@/views/habit/improvement/charts/StatisticCardVerticalTotal.vue'
import StatisticCardVerticalCompleted from '@/views/habit/improvement/charts/StatisticCardVerticalCompleted.vue'
import StatisticCardVerticalPending from '@/views/habit/improvement/charts/StatisticCardVerticalPending.vue'
import StatisticCardVerticalOverdue from '@/views/habit/improvement/charts/StatisticCardVerticalOverdue.vue'
import Ripple from 'vue-ripple-directive'
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton.vue'
import ViewButton from "@/views/components/Shared/Buttons/ViewButton.vue"
import JsonExcel from "vue-json-excel"

export default {
  components: {
    BFormInput,
    BBadge,
    BTable,
    BPagination,
    BFormCheckbox,
    VuePerfectScrollbar,
    Loading,
    TodoTaskHandlerSidebar,
    StatisticCardVerticalCompleted,
    StatisticCardVerticalPending,
    StatisticCardVerticalTotal,
    StatisticCardVerticalOverdue,
    Filters,
    DeleteButton,
    ViewButton,
    JsonExcel
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  setup() {
    const { resolveTagVariant, sendEmailImprovementsOrCommitments, createCommitments } = useCommonTodo()
    const { showSuccessMessage, showErrorMessage } = useNotifications()
    const { getItemsWithAggregate, updateItem, ObjectId } = realmConnection()
    const { getDomains, getDatesFromRange } = useCommonDashboards()
    const { handleError, formatIsoDate } = useCommon()
    const { route } = useRouter()

    const TODO_APP_STORE_MODULE_NAME = 'app-todo'
    const taskToDelete = ref(null)
    const modalIdToDeletd = 'delete-task-modal'
    const userData = store.state?.userStore?.userData
    const clientId = userData.role !== "admin" ? userData.client.$oid : null
    const userRole = userData.role
    const isLoading = ref(true)
    const now = new Date()
    const nowPlusOneWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 7)
    const dateRangeFilter = ref('')
    const domains = computed(() => getDomains(clientId))
    const collection = 'improvement'
    const perPage = ref(20)
    const currentPage = ref(1)
    const sortBy = ref('')
    const isSortDirDesc = ref(false)
    const tasks = ref([])
    const totalTasks = ref(0)
    const statisticCardsData = ref({})
    const supervisorFilter = ref([])
    const userLocations = userData.locations?.length ? userData.locations : null
    const locationFilter = ref(userLocations ? userLocations.map(e => e.value) : [])
    const improvementId = route.value.query.originId
    const originFilter = ref([])
    const roleFilter = ref([])
    const dataExcel = ref([])
    const optionsMetadata = computed(() => store.state[TODO_APP_STORE_MODULE_NAME].optionsMetadata)
    const isTaskHandlerSidebarActive = ref(false)
    const searchQuery = ref("")
    const perfectScrollbarSettings = { maxScrollbarLength: 150, }
    const activeState = ref('total')
    let blankTask = {
      client_id: clientId,
      note: '',
      // dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
      dueDate: null,
      description: '',
      assignee: null,
      tags: [],
      completed: false,
      deleted: false,
      important: false,
      commitments: [],
    }
    const task = ref(JSON.parse(JSON.stringify(blankTask)))
    
    // Register module
    if (!store.hasModule(TODO_APP_STORE_MODULE_NAME)) store.registerModule(TODO_APP_STORE_MODULE_NAME, todoStoreModule)
    
    const clearTaskData = () => {
      task.value = JSON.parse(JSON.stringify(blankTask))
    }

    const fetchTasks = async (searchValue = '') => {
      isLoading.value = true
      try {
        const initialQuery = {
          client_id: ObjectId(clientId),
          deleted: { $ne: true },
        }
        // Creation date
        const creation_date = getDatesFromRange(dateRangeFilter.value)
        if (creation_date[0]) {
          initialQuery.creation_date = { $gte: creation_date[0], $lt: creation_date[1] }
        }
        // Created by
        if (supervisorFilter.value.length > 0) {
          initialQuery.created_by = { $in: supervisorFilter.value.map(e => ObjectId(e)) }
        }
        // Origin
        if (originFilter.value && originFilter.value.length) {
          initialQuery.origin = originFilter.value
        }

        const finalQuery = {}
        
        // Location
        if (locationFilter.value.length) {
          finalQuery['created_by.locations._id'] = { $in: locationFilter.value }
        }
  
        const pipeline = [
          { $match: initialQuery },
          {
            $lookup: {
              from: 'worker',
              localField: 'assignee',
              foreignField: '_id',
              pipeline: [
                { $project: { name: 1, email: 1, locations: 1 } },
                {
                  $lookup: {
                    from: 'location',
                    localField: 'locations',
                    foreignField: '_id',
                    pipeline: [ { $project: { location: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ],
                    as: 'locations',
                  },
                },
                { $addFields: { _id: { $toString: "$_id" } } }
              ],
              as: 'assignee'
            }
          },
          {
            $lookup: {
              from: 'commitment',
              localField: 'commitments',
              foreignField: '_id',
              pipeline: [
                { $addFields: { _id: { $toString: "$_id" }, assignee: { $toString: "$assignee" } } }
              ],
              as: 'commitments'
            }
          },
          {
            $lookup: {
              from: 'worker',
              localField: 'created_by',
              foreignField: '_id',
              pipeline: [
                { $project: { name: 1, email: 1, locations: 1 } },
                {
                  $lookup: {
                    from: 'location',
                    localField: 'locations',
                    foreignField: '_id',
                    pipeline: [ { $project: { location: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ],
                    as: 'locations',
                  },
                },
                { $addFields: { _id: { $toString: "$_id" } } }
              ],
              as: 'created_by'
            }
          },
          { $match: finalQuery },
          { $addFields: { _id: { $toString: "$_id" }, assignee: { $arrayElemAt: ["$assignee", 0] } } },
          { $sort: { creation_date: 1 } }
        ]
  
        const items = await getItemsWithAggregate({ collection, pipeline })
        if (!items) return
  
        // Search
        if (searchValue && searchValue !== searchQuery.value) return
        tasks.value  = searchQuery.value ? items.filter(e => e.note?.toLowerCase().includes(searchQuery.value.toLowerCase())) : items

        // Calculate statistic card values
        let completedTasks = 0
        let pendingTasks = 0
        let overdueTasks = 0
        let dateNow = new Date()

        tasks.value.forEach(i => {
          i.creation_date = i.creation_date ? formatIsoDate(i.creation_date) : '-',
          i.creatorLocations = i.created_by[0] ? i.created_by[0].locations?.map(e => e.location).join(', ') : '-'
          i.created_by = i.created_by[0] ? i.created_by[0].name : '-',
          i.assigneeName = i.assignee?.name
          i.tags = i.tags?.map(e => e)
          i.translatedTags = i.tags?.map(t => computed(() => i18n.t(`domain.${t}`)).value).join(', ')
          i.formatDueDate = i.dueDate ? formatIsoDate(i.dueDate) : ''
          i.formatNote = i.note && i.note?.length > 40 ? `${i.note.slice(0, 40)}...` : i.note || ''
          i.originName = '-'
          
          // Origin: "AI assistance" and "confirmation" can be added if needed
          if(i.origin === 'daily_dialogue' ||  i.origin === 'direct') {
            const originTranslated = i18n.t(`message.${i.origin}`)
            i.originName = originTranslated.charAt(0).toUpperCase() + originTranslated.slice(1)
          }
          if (i.completed) {
            completedTasks++
            i.state = 'completed'
          } else {
            pendingTasks++
            i.state = 'pending'
          }
          // else if (i.dueDate && (i.dueDate < dateNow)) {
          //   overdueTasks++
          //   i.state = 'overdue'
          // } else {
          //   pendingTasks++
          //   i.state = 'pending'
          // }
        })

        dataExcel.value = tasks.value
        totalTasks.value = completedTasks + pendingTasks
        if(activeState.value !== 'total') {
          tasks.value = tasks.value?.filter(task => task.state === activeState.value)
        }
        statisticCardsData.value = {
          total: totalTasks.value,
          completed: completedTasks,
          pending: pendingTasks,
          overdue: overdueTasks
        }
        store.commit('app-todo/SET_STATISTIC_CARDS_DATA', statisticCardsData) 
      } catch (error) {
        console.log(error)
        handleError({ error, defaultMessage: i18n.t('message.err_improvement_list') })
      } finally {
        if (!searchValue || searchValue === searchQuery.value) isLoading.value = false    // Don't remove the loader if the user is still typing a search
      }
    }

    const filterByState = (state) => {
      activeState.value = state
      fetchTasks()
    }

    // Open TodoTaskHandlerSidebar if there is an improvement id in the route query   
    const openSidebarIfImprovementIdExists = async () => {
      if(!improvementId) return
      try {
        const query = { _id: ObjectId(improvementId) }

        const pipeline = [
          { $match: query },
          {
            $lookup: {
              from: 'worker',
              localField: 'assignee',
              foreignField: '_id',
              pipeline: [
                { $project: { name: 1, email: 1, locations: 1 } },
                {
                  $lookup: {
                    from: 'location',
                    localField: 'locations',
                    foreignField: '_id',
                    pipeline: [ { $project: { location: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ],
                    as: 'locations',
                  },
                },
                { $addFields: { _id: { $toString: "$_id" } } }
              ],
              as: 'assignee'
            }
          },
          {
            $lookup: {
              from: 'commitment',
              localField: 'commitments',
              foreignField: '_id',
              pipeline: [
                { $addFields: { _id: { $toString: "$_id" }, assignee: { $toString: "$assignee" } } }
              ],
              as: 'commitments'
            }
          },
          { $addFields: { _id: { $toString: "$_id" }, origin_id: { $toString: "$origin_id" }, assistance: { $toString: "$assistance" }, assignee: { $arrayElemAt: ["$assignee", 0] }, subscribers: { $map: { input: "$subscribers", as: "id", in: { $toString: "$$id" } } } } },
        ]
      
        const items = await getItemsWithAggregate({ collection, pipeline })

        task.value = items[0]
        isTaskHandlerSidebarActive.value = true
      } catch (error) {
        console.log(error)
      }
    }

    // Single Task isCompleted update
    const updateTaskIsCompleted = taskData => {
      taskData.completed = !taskData.completed
      updateTask(taskData, 'update')
    }

    const markCommitmentsAsDeleted = async (commitmentIds = []) => {
      try {
        if (!commitmentIds.length) return

        const updates = commitmentIds.map(id => {
          return updateItem({
            collection: 'commitment',
            query: { _id: ObjectId(id) },
            action: { $set: { deleted: true } },
          })
        })

        await Promise.all(updates)
      } catch (err) {
        console.error('Error updating commitments as deleted:', err)
      }
    }

    const updateTask = async (taskData, action,) => {
      try {
        const query = { _id: ObjectId(taskData._id) }
        const setPayload = {
          note: taskData.note || '',
          assignee: ObjectId(taskData.assignee?._id),
          subscribers: taskData.subscribers?.map(e => ObjectId(e)) || [],
          tags: taskData.tags || [],
          metadata: taskData.metadata || [],
          description: taskData.description || '',
          completed: taskData.completed || false,
          deleted: taskData.deleted || false,
          important: taskData.important || false,
          evidenceKey: taskData.evidenceKey || {},
        }
        const unsetPayload = {}

        if (taskData.dueDate) {
          setPayload.dueDate = taskData.dueDate instanceof Date ? taskData.dueDate : new Date(`${taskData.dueDate.slice(0, 10)} 12:00:00`)
        } else {
          unsetPayload.dueDate = ''
        }

        if (taskData.commitments?.length) {
          let allCommitmentIds = taskData.commitments?.filter(e => e._id).map(e => e._id)

          if (action === 'delete') await markCommitmentsAsDeleted(allCommitmentIds)
          else {
            const newCommitments = taskData.commitments?.filter(e => !e._id)
            const newCommitmentIds = await createCommitments(newCommitments, taskData._id)
            if (newCommitmentIds?.length) allCommitmentIds = [...allCommitmentIds, ...newCommitmentIds]
          }
          if (allCommitmentIds?.length) setPayload.commitments = allCommitmentIds.map(e => ObjectId(e))
        } else {
          setPayload.commitments = []
        }

        const realmAction = { $set: setPayload, $unset: unsetPayload }
        await updateItem({ collection, query, action: realmAction })

        if (action === "delete") showSuccessMessage(i18n.t('message.improvement_deleted'))
        else showSuccessMessage(i18n.t('message.improvement_updated'))

        fetchTasks()

      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('message.improvement_update_error'))
      }
    }

    const removeTask = (taskData) => {
      if (!taskData.deleted) {
        taskData.deleted = true
        updateTask(taskData, "delete")
      }
    }

    const searchTask = searchValue => {
      isLoading.value = true
      fetchTasks(searchValue)
    }

    const resetSearch = () => {
      searchQuery.value = ''
      searchTask()
    }

    const handleTaskClick = taskData => {
      task.value = taskData
      isTaskHandlerSidebarActive.value = true
    }

    const paginatedTaks = computed(() => {
      const start = (currentPage.value - 1) * perPage.value
      const end = start + perPage.value
      return tasks.value.slice(start, end)
    })

    const tableColumns = computed(() => {
      return [
        { key: 'creation_date', label: i18n.t('message.tableHeader.creationDate'), sortable: true },
        // { key: 'formatDueDate', label: i18n.t('message.tableHeader.dueDate'), sortable: true },
        { key: 'created_by', label: i18n.t('message.tableHeader.created_by'), sortable: true },
        // { key: 'assigneeName', label: i18n.t('message.tableHeader.assignee'), sortable: true },
        { key: 'creatorLocations', label: i18n.t('message.tableHeader.creatorLocations'), sortable: true },
        { key: 'tags', label: i18n.t('message.domain'), sortable: true },
        { key: 'formatNote', label: i18n.t('message.tableHeader.Name'), sortable: true },
        { key: 'state', label: i18n.t('message.tableHeader.state'), sortable: true },
        { key: 'originName', label: i18n.t('message.origin'), sortable: true },
        { key: 'actions', label: i18n.t('message.tableHeader.actions') },
      ]
    })

    const excelFields = {
        [i18n.t('message.tableHeader.creationDate')]: "creation_date",
        [i18n.t('message.tableHeader.created_by')]: "created_by",
        // [i18n.t('message.tableHeader.assignee')]: "assigneeName",
        [i18n.t('message.tableHeader.creatorLocations')]: "creatorLocations",
        [i18n.t('message.tableHeader.tags')]: "translatedTags",
        [i18n.t('message.tableHeader.Name')]: "note",
        [i18n.t('message.tableHeader.state')]: "state",
        [i18n.t('message.origin')]: "originName",
        // [i18n.t('message.tableHeader.dueDate')]: "formatDueDate",
    }

    const updateFilter = (data) => {
      locationFilter.value = data.locationFilter
      originFilter.value = data.originFilter
      roleFilter.value = data.roleFilter
      dateRangeFilter.value = data.dateRangeFilter
      supervisorFilter.value = data.supervisorFilter
      if(!data.locationFilter.length && !data.originFilter?.length && !data.roleFilter.length && !data.dateRangeFilter.length && !data.supervisorFilter.length) {
        activeState.value = 'total'
      } 
      fetchTasks()
    }


    watch([locationFilter, dateRangeFilter, searchQuery, sortBy, isSortDirDesc], () => {
      isLoading.value = true
      fetchTasks()
    })

    onMounted(async () => {
      fetchTasks()
      openSidebarIfImprovementIdExists()
    })

    return {
      task,
      tasks,
      totalTasks,
      removeTask,
      updateTask,
      clearTaskData,
      searchQuery,
      fetchTasks,
      perfectScrollbarSettings,
      searchTask,
      resetSearch,
      isLoading,
      domains,
      optionsMetadata,
      resolveTagVariant,
      isTaskHandlerSidebarActive,
      handleTaskClick,
      dataExcel,
      excelFields,
      tableColumns,
      updateFilter,
      perPage,
      currentPage,
      sortBy,
      isSortDirDesc,
      paginatedTaks,
      userRole,
      statisticCardsData,
      taskToDelete,
      modalIdToDeletd,
      updateTaskIsCompleted,
      filterByState,
      activeState
    }
  },
}
</script>

<style lang="scss" scoped>
.draggable-task-handle {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;
  cursor: move;

  .todo-task-list .todo-item:hover & {
    visibility: visible;
  }
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-todo.scss";
</style>

<style lang="scss" scoped>
.chatbot{
  width: 2.7rem;
  margin-right: 0.5rem;
  height: auto;
  padding-left: 0.5rem;
  opacity: 0.5;
}
</style>
